import { Events, NavController, ActionSheet, Modal, Alert } from 'ionic-angular'
import { Component, NgZone } from '@angular/core'
import { Http } from '@angular/http'
import { ItineraryPage } from '../itinerary/itinerary'
import { LocationPage } from '../stop/location'
import { SchedulesPage } from '../stop/schedules'
import { Map } from '../home/map'
import { SearchModal } from '../search/search'
import { MoreModal } from '../more/more'
import { Geolocation } from '../../services/geolocation'
import { Datetime, Minutes } from '../../pipes/datetime'
import { DOMAIN } from '../../config'

@Component({
  templateUrl: 'build/pages/home/home.html',
  directives: [Map],
  providers: [Geolocation],
  pipes: [Datetime, Minutes]
})
export class HomePage {
  private lines: any = Array
  private options: any = Object

  constructor(private http: Http, private events: Events, private nav: NavController, private geolocation: Geolocation, private zone: NgZone) {
    this.lines = []

    // Sliders options
    this.options = {
      paginationClickable: false,
      /*onClick: (slider, e) => {
        console.log(slider, e)
      },*/
      onSlideChangeStart: (slider, e) => {
        let container = slider.container[0]
        let index = slider.activeIndex
        let pagination = container.querySelectorAll('.swiper-pagination-bullet')

        if (index === 0) {
          pagination[0].className = 'swiper-pagination-bullet swiper-pagination-bullet-active'
          pagination[1].className = 'swiper-pagination-bullet'
        } else {
          pagination[1].className = 'swiper-pagination-bullet swiper-pagination-bullet-active'
          pagination[0].className = 'swiper-pagination-bullet'
        }
      }
    }

    events.subscribe('carpostal:near:get', (data) => {
      let lines = data.shift()

      // NgZone is like the old $apply, forcing the view to update her content from the model
      zone.run(() => {
        this.lines = lines
        events.publish('carpostal:map:schedules')

        // Update containers colors
        setTimeout(() => {
          let containers = document.querySelectorAll('.swiper-container')
          for (let i = 0; i < lines.length; ++i) {
            (<HTMLElement>containers[i]).style['background-color'] = '#' + lines[i].routes[0].color
          }
        })
      })
    })

    events.subscribe('carpostal:home:selected', data => {
      let place = data.shift()

      events.publish('carpostal:map:move', place)
    })

    // Schedules
    events.subscribe('carpostal:map:schedules', () => {
      for (let line of this.lines) {
        for (let route of line.routes) {
          this.schedules(route)
        }
      }
    })
  }

  ngAfterViewInit() {
    let coords = [
      {
        lat: 43.512618,
        lng: 3.367453
      },
      {
        lat: 43.250900,
        lng: 3.387914
      },
      {
        lat: 43.315691,
        lng: 3.828833
      },
      {
        lat: 43.521521,
        lng: 3.803258
      }
    ]
    let polygon = new google.maps.Polygon({
      paths: coords
    })

    this.geolocation.position((position) => {
      let lat = position.coords.latitude
      let lng = position.coords.longitude

      if (google.maps.geometry.poly.containsLocation(new google.maps.LatLng(lat, lng), polygon)) {
        this.events.publish('carpostal:map:location', new google.maps.LatLng(lat, lng))
      }
    }, (err) => {
      // error
      /*if (err.code === 1) {
        popup.alert({
          title: 'Géolocation impossible',
          template: 'Nous n\'avons pas pu vous localiser car vous avez refusé la localisation'
        })
      } else if (err.code === 2) {
        popup.alert({
          title: 'Géolocation impossible',
          template: 'Nous n\'avons pas pu vous localiser à cause d\'une erreur GPS'
        })
      } else {
        popup.alert({
          title: 'Géolocation impossible',
          template: 'Nous n\'avons pas pu vous localiser car aucune information n\'a été recue'
        })
      }*/
    }, {})

    // Paralax !
    let scroll = (<HTMLElement>document.querySelector('ion-content')).children[0];
    let map = <HTMLElement>document.querySelector('.home-map');

    scroll.addEventListener('scroll', e => {
      let scrollTop = (<HTMLElement>e.target).scrollTop
      let scrollFactor = scrollTop / 2

      this.zone.run(() => {
        map.style['-webkit-transform'] = 'translate3d(0, +' + scrollFactor + 'px, 0)'
      })
    })
  }

  schedules(route) {
    this.http
      .get(`//${DOMAIN}/api/schedules?line=${route.id}&stop=${route.nearest.id}&count=3`)
      .map(res => res.json())
      .subscribe(data => {
        if (data.departures.length) {
          route.schedules = data.departures
        } else {
          route.noschedule = true
        }
      },
      err => console.error(err))
  }

  clickSlide(event) {
    let actionSheet = ActionSheet.create({
      buttons: [
        {
          text: 'Localiser l\'arrêt',
          handler: () => {
            let navTransition = actionSheet.dismiss()
            navTransition.then(() => {
              this.nav.push(LocationPage, {
                stop: event.nearest
              })
            })

            return false
          }
        }, {
          text: 'Voir les autres horaires',
          handler: () => {
            let navTransition = actionSheet.dismiss()
            navTransition.then(() => {
              this.nav.push(SchedulesPage, {
                route: event
              })
            })

            return false
          }
        }, {
          text: 'Annuler',
          role: 'cancel'
        }
      ],
      title: event.nearest.title
    })
    this.nav.present(actionSheet)
  }

  itinerary() {
    this.nav.push(ItineraryPage)
  }

  search() {
    this.nav.present(Modal.create(SearchModal, {
      input: document.querySelector('.searchbar-input'),
      parent: 'home'
    }))
  }

  more() {
    this.nav.present(Modal.create(MoreModal))
  }
}
